

import { useMutation } from "@tanstack/react-query";
import { DataOrParams, POST } from "../services/requests";
import { ENDPOINTS } from "../constants/endpoints";

export const useChangeSubscription = () => {
  const mutation = useMutation({
    mutationFn: async (payload: DataOrParams) => {
        const data = await POST(`${ENDPOINTS.changeSubscription}`, payload);
        return data;
    }
});

  return { ...mutation };
};
